(function() { window.GUID_9c5edf76_9398_4258_87f8_d2e6ca044990 = { getGuid: function() { return "9c5edf76-9398-4258-87f8-d2e6ca044990"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class DatePicker extends Controls.ControlValueBase {
            constructor(id, options) {
                super(id, options);
                this.options = options;
            }
            OnBindEvents() { }
            OnDispose() {
                if (this.isCalendarMode)
                    this.$datePickerTarget.off("change." + this.ControlId);
                else
                    this.$Control.off("change." + this.ControlId);
                this.$datePickerTarget.datepicker("destroy");
            }
            get ControlId() {
                return this.$divContainer.attr("id");
            }
            get $Control() {
                return this.$divContainer;
            }
            OnControlInstantiation(params) {
                if (this.options && this.options.jqueryUiDatePickerOptions)
                    this.Options = this.options.jqueryUiDatePickerOptions;
                let me = this;
                this.$divContainer = $(params[0]); //contient le Id
                this.bindOptions();
                me.$input = me.$Control.find('input:not(".original-value"):not(".altfield")');
                me.$altField = me.$Control.find(".altfield");
                if (me.isCalendarMode) {
                    me.$datePickerTarget = me.$Control.find(".calendar");
                    me.$datePickerTarget.offon("change." + this.ControlId, function (e) {
                        const datePickerDate = me.$datePickerTarget.datepicker("getDate");
                        me.$input.val(me.$datePickerTarget.datepicker().val());
                        me.$altField.val(me.convertDateToString(datePickerDate));
                        var data = {
                            StrDate: me.GetValue(),
                            Date: datePickerDate,
                        };
                        me.Trigger(DatePicker.EventNames.DatePickerValueChanged, { jqueryEventObject: e, data });
                        //me.Call(EventEnum.ValueChanged, { value: me.GetValue() }, e);
                    });
                }
                else {
                    me.$datePickerTarget = me.$input;
                    //this.$Control.offon('keyup.' + this.ControlId + ' change.' + this.ControlId, function (e) {
                    this.$Control.offon("change." + this.ControlId, function (e) {
                        if (e.keyCode == 9 || (e.keyCode > 36 && e.keyCode < 41)) {
                            return;
                        }
                        const datePickerDate = me.$datePickerTarget.datepicker("getDate");
                        me.$altField.val(me.convertDateToString(datePickerDate));
                        var data = {
                            StrDate: me.GetValue(),
                            Date: datePickerDate,
                        };
                        me.Trigger(DatePicker.EventNames.DatePickerValueChanged, { jqueryEventObject: e, data });
                        if (me.canClear) {
                            me.$Control.find(".clear-date").toggle(data.StrDate != "");
                        }
                    });
                }
                me.BuildDatePicker();
                if (me.canClear) {
                    me.$Control.find(".clear-date").toggle(me.GetValue() != "");
                    me.$Control.offon("click.clear" + this.ControlId, ".clear-date", function (e) {
                        me.SetValue("");
                        var data = {
                            StrDate: "",
                            Date: null,
                        };
                        me.Trigger(DatePicker.EventNames.DatePickerValueChanged, { jqueryEventObject: e, data });
                        me.$Control.find(".clear-date").hide();
                    });
                }
            }
            bindOptions() {
                let me = this;
                me.disabled = me.$Control.data("disabled") == "True";
                me.isCalendarMode = me.$Control.data("iscalendarmode") == "True";
                me.isMonthPicker = me.$Control.data("ismonthpicker") == "True";
                me.minDate = me.parseDateString(me.$Control.data("mindate"));
                me.maxDate = me.parseDateString(me.$Control.data("maxdate"));
                me.currentDate = me.parseDateString(me.$Control.data("currentdate"));
                me.defaultDate = me.parseDateString(me.$Control.data("defaultvalue"));
                me.canClear = me.$Control.data("canclear") == "True";
                let dates = me.$Control.data("specialdates");
                if (dates) {
                    let dateList = dates.map(function (e) {
                        return new DatePicker.SpecialDate(e, false, "avail");
                    });
                    this.SetSpecialDates(dateList, true, false);
                }
                if (me.options && me.options.disabled != null)
                    me.disabled = me.options.disabled;
                if (me.options && me.options.isCalendarMode != null)
                    me.isCalendarMode = me.options.isCalendarMode;
                if (me.options && me.options.isMonthPicker != null)
                    me.isMonthPicker = me.options.isMonthPicker;
                if (me.options && me.options.minDate != null)
                    me.minDate = me.options.minDate;
                if (me.options && me.options.maxDate != null)
                    me.maxDate = me.options.maxDate;
                if (me.options && me.options.canClear != null)
                    me.canClear = me.options.canClear;
            }
            BuildDatePicker() {
                let me = this;
                let yearRange = "-100:+5";
                me.$datePickerTarget.datepicker("destroy");
                const defaultValue = me.parseDateString(me.$Control.data("defaultvalue"));
                var options = {
                    changeMonth: true,
                    changeYear: true,
                    numberOfMonths: 1,
                    yearRange: yearRange,
                    showButtonPanel: true,
                    minDate: me.minDate,
                    maxDate: me.maxDate,
                    defaultDate: me.currentDate
                        ? me.currentDate
                        : defaultValue,
                    //altField: me.$altField.length > 0 ? me.$altField : undefined,
                    //altFormat: "yy-mm-dd",
                    beforeShowDay: (date) => {
                        return me.compareAgainstSpecialDates(date);
                    },
                    //onSelect: (date, instance) => {
                    //    var inst = instance;
                    //}
                };
                if (this.Options)
                    options = $.extend(options, this.Options);
                me.$datePickerTarget.datepicker(options);
                let initialDate = me.parseDateString(me.$altField.val());
                me.AddFrenchLang();
                me.$datePickerTarget.datepicker("setDate", initialDate);
                if (me.disabled) {
                    this.$datePickerTarget.datepicker("disable");
                }
                else {
                    this.$datePickerTarget.datepicker("enable");
                }
                me.$datePickerTarget
                    .find(".ui-datepicker-current-day")
                    .removeClass("ui-datepicker-current-day");
                //if (me.isMonthPicker) {
                //    let test = me.$datePickerTarget.find('.ui-datepicker');
                //    test.addClass('ismonthpicker');
                //}
                if (me.isCalendarMode)
                    this.SelectedDate = initialDate;
            }
            Disable() {
                this.disabled = true;
                this.BuildDatePicker();
            }
            Enable() {
                this.disabled = false;
                this.BuildDatePicker();
            }
            SetMinDate(date, rebuildImmediately = false) {
                this.minDate = date;
                if (rebuildImmediately) {
                    this.BuildDatePicker();
                }
            }
            SetMaxDate(date, rebuildImmediately = false) {
                this.maxDate = date;
                if (rebuildImmediately) {
                    this.BuildDatePicker();
                }
            }
            Show() {
                this.$datePickerTarget.datepicker("show");
            }
            Hide() {
                this.$datePickerTarget.datepicker("hide");
            }
            SetSpecialDates(dates, useAsRangeLimit, rebuildDatePicker = true) {
                if (dates != null && dates.length > 0) {
                    this.useSpecialDatesAsRangeLimit = useAsRangeLimit;
                    dates.sort(function (a, b) {
                        return a.Date.getTime() - b.Date.getTime();
                    });
                    this.specialDates = dates;
                    if (useAsRangeLimit) {
                        let start = dates[0];
                        let end = dates[dates.length - 1];
                        this.SetMinDate(start.Date);
                        this.SetMaxDate(end.Date);
                    }
                    if (rebuildDatePicker) {
                        this.BuildDatePicker();
                    }
                }
            }
            compareAgainstSpecialDates(date) {
                if (this.specialDates == null) {
                    return [true, "", ""];
                }
                for (var i = 0; i < this.specialDates.length; i++) {
                    let specialDate = this.specialDates[i];
                    if (date.getTime() === specialDate.Date.getTime()) {
                        return [
                            !specialDate.Disabled,
                            specialDate.CssClass,
                            specialDate.Tooltip,
                        ];
                    }
                }
                return [!this.useSpecialDatesAsRangeLimit, "", ""];
            }
            AddFrenchLang() {
                var _a, _b, _c, _d;
                $.datepicker.regional["fr"] = {
                    clearText: "Effacer",
                    clearStatus: "",
                    closeText: "Fermer",
                    closeStatus: "Fermer sans modifier",
                    prevText: "Préc",
                    prevStatus: "Voir le mois précédent",
                    nextText: "Suiv",
                    nextStatus: "Voir le mois suivant",
                    currentText: "Aujourd'hui",
                    currentStatus: "Voir le mois courant",
                    monthNames: [
                        "Janvier",
                        "Février",
                        "Mars",
                        "Avril",
                        "Mai",
                        "Juin",
                        "Juillet",
                        "Août",
                        "Septembre",
                        "Octobre",
                        "Novembre",
                        "Décembre",
                    ],
                    monthNamesShort: [
                        "Jan",
                        "Fév",
                        "Mar",
                        "Avr",
                        "Mai",
                        "Jun",
                        "Jul",
                        "Aoû",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Déc",
                    ],
                    monthStatus: "Voir un autre mois",
                    yearStatus: "Voir un autre année",
                    weekHeader: "Sm",
                    weekStatus: "",
                    dayNames: [
                        "Dimanche",
                        "Lundi",
                        "Mardi",
                        "Mercredi",
                        "Jeudi",
                        "Vendredi",
                        "Samedi",
                    ],
                    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                    dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
                    dayStatus: "Utiliser DD comme premier jour de la semaine",
                    dateStatus: "Choisir le DD, MM d",
                    firstDay: 0,
                    initStatus: "Choisir la date",
                    isRTL: false,
                };
                $.datepicker.regional["fi"] = {
                    closeText: "Sulje",
                    prevText: "&laquo;Edellinen",
                    nextText: "Seuraava&raquo;",
                    currentText: "T&auml;n&auml;&auml;n",
                    monthNames: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kes&auml;kuu",
                        "Hein&auml;kuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"],
                    monthNamesShort: ["Tammi", "Helmi", "Maalis", "Huhti", "Touko", "Kes&auml;",
                        "Hein&auml;", "Elo", "Syys", "Loka", "Marras", "Joulu"],
                    dayNamesShort: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "Su"],
                    dayNames: [
                        "Sunnuntai",
                        "Maanantai",
                        "Tiistai",
                        "Keskiviikko",
                        "Torstai",
                        "Perjantai",
                        "Lauantai"
                    ],
                    dayNamesMin: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
                    weekHeader: "Vk",
                    dateFormat: "dd.mm.yy",
                    firstDay: 1,
                    isRTL: false,
                    showMonthAfterYear: false,
                    yearSuffix: ""
                };
                if (((_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en") == "fr") {
                    $.datepicker.setDefaults($.datepicker.regional["fr"]);
                    $.datepicker.setDefaults({ dateFormat: "yy-mm-dd" });
                }
                else if (((_d = (_c = CS.CommonData.Current.Language) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : "en") == "fi") {
                    $.datepicker.setDefaults($.datepicker.regional["fi"]);
                    $.datepicker.setDefaults({ dateFormat: "dd.mm.yy" });
                }
                else {
                    $.datepicker.setDefaults($.datepicker.regional[""]);
                }
            }
            //GetValue est la methode a privilegier parce que celle-ci evite des probleme dans une querystring puisqu elle est formatté avec des - et non des /
            GetValue() {
                var date = this.SelectedDate;
                if (!date) {
                    return "";
                }
                return this.convertDateToString(date);
                //var year: any = date.getFullYear();
                //var month: any = date.getMonth() + 1;
                //var day: any = date.getDate();
                //if (month.toString().length == 1) {
                //    month = "0" + month;
                //}
                //if (day.toString().length == 1) {
                //    day = "0" + day;
                //}
                //return year + "-" + month + "-" + day;
            }
            SetValue(value) {
                const dateValue = this.parseDateString(value);
                //this.$input.val(value);
                if (this.isCalendarMode) {
                    this.$datePickerTarget.datepicker("setDate", dateValue);
                }
                else if (this.canClear) {
                    this.$Control.find(".clear-date").toggle(value != "");
                }
            }
            get SelectedDate() {
                return this.$datePickerTarget.datepicker("getDate");
            }
            set SelectedDate(date) {
                this.$datePickerTarget.datepicker("setDate", date);
            }
            parseDateString(dateString) {
                let result = null;
                if (dateString) {
                    result = $.datepicker.parseDate("yy-mm-dd", dateString.substring(0, 10));
                }
                return result;
            }
            convertDateToString(date) {
                if (date == null)
                    return "";
                return $.datepicker.formatDate("yy-mm-dd", date) + " 00:00:00";
            }
        }
        Controls.DatePicker = DatePicker;
        (function (DatePicker) {
            class Events extends Controls.ControlValueBase.Events {
                static DatePickerValueChanged(param) {
                    Controls.RegisterEvent(DatePicker, EventNames.DatePickerValueChanged, param);
                }
            }
            DatePicker.Events = Events;
            class EventNames extends Controls.ControlValueBase.EventNames {
            }
            EventNames.DatePickerValueChanged = "datepicker-valuechanged";
            DatePicker.EventNames = EventNames;
            class SpecialDate {
                constructor(date, disabled, cssClass = "", tooltip = "") {
                    let realDate = new Date(date);
                    /*Tweak qui retire l'offset du time zome mais en restant dans ce meme time zone*/
                    //realDate.setTime(realDate.getTime() + realDate.getTimezoneOffset() * 60000);
                    this.Date = realDate;
                    this.Disabled = disabled;
                    this.CssClass = cssClass;
                    this.Tooltip = tooltip;
                }
            }
            DatePicker.SpecialDate = SpecialDate;
        })(DatePicker = Controls.DatePicker || (Controls.DatePicker = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));
$.datepicker._gotoToday = function (id) {
    //Ici, ça fait en sorte que dans le datepicker, si je clique le bouton
    //today, celui-ci sélectionne la date d'aujourd'hui, sinon, il ne ferait que
    //naviguer faire la date sans la sélectionner.
    var target = $(id);
    var inst = this._getInst(target[0]);
    if (this._get(inst, "gotoCurrent") && inst.currentDay) {
        inst.selectedDay = inst.currentDay;
        inst.drawMonth = inst.selectedMonth = inst.currentMonth;
        inst.drawYear = inst.selectedYear = inst.currentYear;
    }
    else {
        var date = new Date();
        inst.selectedDay = date.getDate();
        inst.drawMonth = inst.selectedMonth = date.getMonth();
        inst.drawYear = inst.selectedYear = date.getFullYear();
        this._setDateDatepicker(target, date);
        this._selectDate(id, this._getDateDatepicker(target));
    }
    this._notifyChange(inst);
    this._adjustDate(target);
};

//# sourceMappingURL=datepicker.js.map
